export default function findItemInCart(id, items) {
    let productChanged;
    items.forEach((productInCart) => {
        if (productInCart.itemId === id) {
            productChanged = productInCart;
        } else if (!productChanged && productInCart.items) {
            productChanged = findItemInCart(id, productInCart.items);
        }
    });
    return productChanged;
}
